const types = {
  VALIDATE_ZIPCODE: '@@IO_ADMIN/VALIDATE_ZIPCODE',
  GET_FOCUS: '@@IO_ADMIN/GET_FOCUS',
};

export default types;
